import type { PageHealth } from 'api/new-analytics/types';

export type AnalyticsReconnectOutcome =
  | 'recovered'
  | 'still-expired'
  | 'unknown';

export function classifyAnalyticsReconnectOutcome(
  healthAfterReconnect: PageHealth | undefined,
): AnalyticsReconnectOutcome {
  if (healthAfterReconnect == null) {
    return 'unknown';
  }

  return healthAfterReconnect.health_status === 'token_expired'
    ? 'still-expired'
    : 'recovered';
}

// `useToast` derives the toast id from the message when none is given, so two
// identical "reconnect did not take effect" messages would dedupe and the user
// would see nothing on a retry. Keep every attempt distinct.
export function buildAnalyticsReconnectToastId(
  pageId: number,
  attemptedAt: number,
): string {
  return `analytics-reconnect-ineffective-${pageId}-${attemptedAt}`;
}

export function buildAnalyticsReconnectOutcomeLog(params: {
  pageId: number;
  outcome: AnalyticsReconnectOutcome;
  healthBeforeReconnect: PageHealth | undefined;
  healthAfterReconnect: PageHealth | undefined;
}) {
  const { pageId, outcome, healthBeforeReconnect, healthAfterReconnect } =
    params;

  return {
    pageId,
    outcome,
    healthStatusBefore: healthBeforeReconnect?.health_status ?? null,
    healthStatusAfter: healthAfterReconnect?.health_status ?? null,
    lastSuccessfulSyncAt: healthAfterReconnect?.last_successful_sync_at ?? null,
    consecutiveFailures: healthAfterReconnect?.consecutive_failures ?? null,
  };
}
